module.exports = __webpack_public_path__ + "img/champions.fd4f3c37.svg";